import { PROFILE_EDIT_URL, SITE_BASE_URL } from '@/config'
import UserChild from '@/models/UserChild'
import Subscription from '@/models/Subscription'

export default class UserProfile {
  constructor (data) {
    if (!data.id) throw new Error('Invalid user profile data.')

    this.id = data.id
    this.uuid = data.uuid
    this.firstName = data.first_name ?? ''
    this.lastName = data.last_name ?? ''
    this.avatarUrl = !data.avatar.includes('120.png')
      ? data.avatar
      : `${SITE_BASE_URL}assets/images/icons/user.svg`
    this.email = data.email ?? null
    this.role = data.role ?? 'Родитель'
    this.city = data.city ?? ''
    this.profileUrl = data.profile_url ?? PROFILE_EDIT_URL
    this.children = data.children
      ? data.children.map((data, index) => new UserChild(data, this, index))
      : []
    this.showTutorial = data.show_tutorial ?? false
    this.subscription = new Subscription({})
    this.subscriptions = null
  }

  get hasSubscriptions () {
    return !!this.subscriptions?.some(o => o.bought)
  }

  get fullName () {
    return `${this.firstName} ${this.lastName}`.trim()
  }

  get hasChildren () {
    return this.children.length > 0
  }
}
